import { ChevronRight } from 'lucide-react';
import { FC } from 'react';

import { Container, Title, TitleContainer } from './Banner.styled';

export type BannerProps = {
  image: string;
  title?: string;
  height?: string;
  action?: () => void;
};

export const Banner: FC<BannerProps> = ({ image, title, action, height }) => (
  <Container onClick={action} background={image} data-testid="banner" height={height || '200px'}>
    <TitleContainer>
      {title
      && (
      <>
        <ChevronRight size={14} color="#FFFFFF" />
        <Title>{title}</Title>
      </>
      )}
    </TitleContainer>
  </Container>
);
